import request from 'utils/request'
/*---------  菜单管理    -------*/

//获取菜单列表
export const getMenuData = data => request().post('menu/page', data)
//添加菜单列表
export const addMenu = data => request().post('menu/add', data)
//获取权限配置
export const getMenuList = () => request().get('menu/list')
//删除
export const deleteMenu = id => request().get(`menu/delete/${id}`)
